// @flow

import React from "react";
import { localize } from "redux-i18n";
import type { StandardQuestionContent } from "@modules/service/reducer/standard-questions/types";
import { Button, SchemaForm, Modal, ModalBody, ModalFooter, ModalHeader, Col } from "@components";
import uiSchema from "./uiSchema";

type OwnProps = $Exact<{
  onCancel: () => void,
  onSubmit: (form: Object) => void,
  formData: StandardQuestionContent,
  schema: ?Object,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class StandardQuestionEditModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  submitForm = () => {
    if (this.formRef) {
      this.formRef.current.submit();
    }
  };

  handleSubmit = (formData: Object) => {
    if (formData) {
      const updatedDraft = { ...this.props.formData, ...formData, advisorType: "ALL" };
      this.props.onSubmit(updatedDraft);
    }
  };

  render() {
    return (
      <Modal className="modal-normal">
        <ModalHeader toggle={this.props.onCancel} className="d-flex justify-content-between">
          {this.props.t("EDIT_FOR_NAME", {
            name: this.props.formData.standardQuestion.name,
          })}
        </ModalHeader>
        <ModalBody>
          <SchemaForm
            ref={this.formRef}
            formData={this.props.formData}
            schema={this.props.schema}
            onSubmit={this.handleSubmit}
            uiSchema={uiSchema}
            externalSubmit
          />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onCancel}>
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon="save" onClick={this.submitForm}>
            {this.props.t("SAVE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(StandardQuestionEditModal);
